import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { DeviceLocationReducer, MdmDeviceLocationFeatureKey } from './device-location.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DeviceLocationEffects } from './device-location.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(MdmDeviceLocationFeatureKey, DeviceLocationReducer),
    EffectsModule.forFeature([DeviceLocationEffects]),
  ],
  providers: [],
})
export class DeviceLocationStoreModule {}
